const get = async (url) => {
  const response = await fetch(url, { credentials: 'same-origin' });

  if (!response.ok) return { error: true, status: response.status };

  return response.json();
}

export default {
  get
}
